import React, { useState } from "react";
import { NavbarBroker } from "./NavbarBroker";
import { NavbarMobileBroker } from "./NavbarMobileBroker";
import ModalHorario from "./ModalHorario";

const Horarios = () => {
    const [modalHorario, setModalHorario] = useState(false);
    return (
        <div className="mt-10">
            {/* <ModalHorario
                modalHorario={modalHorario}
                setModalHorario={setModalHorario}
            /> */}
            <NavbarBroker titulo="Horarios">
                <div className="flex items-end justify-end w-full mx-10 ">
                    <div
                        onClick={() => setModalHorario(true)}
                        className="p-2 px-5 text-white bg-blue-500 rounded-lg cursor-pointer hover:scale-105">
                        Editar Horarios
                    </div>
                </div>
                <NavbarMobileBroker />
            </NavbarBroker>
        </div>
    );
};

export default Horarios;
